import { Shield } from "lucide-react";

export default function PrivacyPolicyScreen() {
  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      <div className="px-4 sm:px-6 md:px-8 lg:px-16 xl:px-24 py-8 md:py-12">
        {/* Header */}
        <div className="text-center mb-8 md:mb-12">
          <div className="flex justify-center mb-4">
            <div className="rounded-full bg-primary-light p-4">
              <Shield className="w-8 h-8 md:w-12 md:h-12 text-primary" />
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            תנאי שימוש ופרטיות
          </h1>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-6 md:p-8 lg:p-12">
          <div className="prose prose-sm md:prose-base lg:prose-lg max-w-none">
            {/* Company Info */}
            <section className="mb-8 text-center border-b pb-6">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                מ.פ איי טיי גרופ בעמ - MFiT Group LTD
              </h2>
              <p className="text-gray-600 mb-2">ח.פ. 517119558</p>
              <p className="text-gray-600 font-semibold mb-1">כתובת העסק</p>
              <p className="text-gray-600">התאנה 16 לב הארץ, כפר קאסם</p>
            </section>

            {/* Definitions */}
            <section className="mb-8">
              <p className="text-gray-700 mb-4 leading-relaxed">
                <strong>הלקוח:</strong> כל לקוח קצה אשר רכש או קיבל מנוי ואשר
                עושה או יכול לעשות שימוש בשרות.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                <strong>השרות:</strong> המרת הודעות טקסט להודעות קוליות, המרת
                הודעות קוליות להודעות טקסט, הצגת מספר מתקשר כאשר מקור השיחה
                מוגדר כחסום והכל בכפוף להוראות כל דין וכן בהתאם למגבלות טכניות
                של השרות וכפי שיהיו מעת לעת.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                <strong>הכרטיס:</strong> כרטיס טעינה בעל קוד ייחודי באמצעותו
                ניתן לרכוש מנוי לשרות באופן בלתי מקוון.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                <strong>מנוי מקוון:</strong> מנוי אשר נרכש באופן מקוון באמצעות
                מפיץ מורשה מטעם החברה.
              </p>
            </section>

            {/* Terms of Use */}
            <section className="mb-8">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                תנאי השימוש ומטרת השימוש
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                באישור תקנון תנאי השימוש בשרות, הלקוח מאשר כי בתוכן התקנון
                מתמצים היחסים המשפטיים והחוזיים שבינו לבין החברה וכי אין לחברה
                כל אחריות בגין השרות, למעט כמתחייב על ידה מפורשות על פי תקנון
                זה.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                באישור תקנון זה מקבל על עצמו הלקוח את כל תנאיה של החברה לשימוש
                בשרות, בין אם נרכש על דרך של כרטיס ובין אם נרכש כמנוי מקוון
                ובמקרה בו יבקש שלא לקבלם ולאשרם הוא מנוע מלעשות כל שימוש בשרות
                ו/או בחלקו ולחברה לא תהא כל אחריות כלפיו וללא זכות השבה.
              </p>
            </section>

            {/* Intellectual Property */}
            <section className="mb-8">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                קניין רוחני
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                הלקוח מאשר כי ידוע לו שמלוא זכויות הקניין הרוחני בשרות ולרבות
                העומד ביסודם ואופן אספקת השרות, עיצוב, תוכן, זיהוי, אופן שימוש,
                ממשק, קוד מחשב, קבצים, טקסט ותמונות וכן כל דבר או פרט אחר הנובע
                ו/או הקשור ו/או הגלום בשרות הינם קניינה הרוחני של החברה ואין
                ללקוח כל זכות ו/או רשות לעשות בהם שימוש כלשהו, למעט שימוש
                המתחייב והנובע משימוש מקובל וסביר בשרות ואשר נובע ממנו באופן
                ישיר.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                הלקוח מתחייב כי לא יפיץ, ישכפל, יעתיק בכל צורה שהיא, בין בעצמו
                ובין באמצעות מי מטעמו את השרות ו/או כל חלק ממנו או מרכיביו
                וכמפורט לעיל.
              </p>
            </section>

            {/* Privacy and Confidentiality */}
            <section className="mb-8">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                פרטיות משתמש וסודיות
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                החברה לא תעשה שימוש במידע ו/או נתונים אישיים של הלקוח, למעט אלה
                הדרושים לצרכי תפעול שוטף של השרות הניתן על כל חלקיו. באישור
                תקנון זה נותן הלקוח רשות מפורשת לשימוש בנתונים כאמור ובמקרה בו
                יבקש לקוח שלא לאפשר שימוש בנתונים אלה ע"י החברה, אזי יהא עליו
                שלא לאשר תקנון זה, לא להשלים את הליך ההרשמה לשרות ושלא לקבלו.
                אין באמור לעיל כדי לגרוע ממדיניות הביטולים של החברה המהווה חלק
                בלתי נפרד מתקנון זה והכל כפי המפורט להלן.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                הלקוח מאשר כי ידוע לו שלא ניתן לספק לו את השרות מבלי שהחברה תעשה
                שימוש במידע ו/או בנתונים האישיים שלו לרבות רשימת אנשי קשר וכן
                פרטי מידע אחרים השייכים לו וכי הסכמתו לשימוש בכל אלה הינה תנאי
                יסודי להתקשרותו עם החברה ולהיותו לקוח של החברה ולקבלת השרות כולו
                או חלקו. הלקוח מאשר כי ידוע לו שכל מידע ו/או נתונים אשר נמצאים
                במכשיר האלקטרוני באמצעותו הוא עושה שימוש בשרות (בין מכשיר
                אלקטרוני השייך לו ובין השייך לכל צד ג' אחר) עשוי להיות חשוף
                למשתמשים ו/או מנויים ו/או לקוחות אחרים של השרות ושל החברה וכי
                משכך הוא מתחייב באישורו את תקנון זה שלא להחזיק מידע ו/או נתונים
                אשר עשויים להיות פוגעניים כלפי צד ג' והאחריות לכל מידע שכזה תחול
                על הלקוח בלבד.
              </p>
            </section>

            {/* System Usage Responsibility */}
            <section className="mb-8">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                אחריות לשימוש במערכת
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                כאמור לעיל מטרת השרות הינה נוחות, הנגשת שרות המערכת לקהלים
                מסוימים והנאה.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                השימוש במערכת בעת נהיגה ברכב מנועי ו/או אחר ו/או ביצוע כל פעולה
                אשר במהלכה נאסר לעשות שימוש במכשיר סלולרי הינו אסור בהחלט
                והשימוש במערכת יבוצע בכפוף להוראות כל דין. אין באספקת השרות ו/או
                העמדתו לרשות הלקוח כדי להוות משום הצעה לשימוש ו/או מצג לרבות מצג
                שווא לפיו השימוש בשרות יכול ויעשה בעת נהיגה וכיוצא באלה פעולות
                אחרות.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                השימוש במערכת הינו באחריות הלקוח/החנות בלבד, ואין החברה אחראית
                לכל תוצאה ו/או השלכה שתהא לשימוש בו. החברה לא תשא באחריות לגילוי
                או חשיפה של מידע / נתון ו/או קבלת כל ידיעה אשר תנבע מהשימוש
                בשרות בין במישרין ובין בעקיפין, בין ע"י הלקוח ובין ע"י כל צד ג'
                אחר.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                הלקוח מאשר כי ידוע לו כי תנאי קליטה במכשיר הסלולרי, תקלות במכשיר
                הסלולרי, רעשי רקע, תקלות שידור, תקלות קליטה וכן כל תקלה אחרת
                עשויים להשפיע על אופן פעולת המערכת וכל אחד ואחד מהם עשוי לשבש
                ו/או לעוות ו/או לשנות את תוכן ההודעה שתתקבל אצל הצד השני ולא
                תחול על החברה כל אחריות בקשר עם כך.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                הלקוח מאשר כי ידוע לו שהשרות או כל חלק ממנו עשויים לעתים שלא
                לפעול כראוי ולא תהיה לו כל טענה ו/או דרישה בקשר עם כך ו/או בקשר
                עם מהימנות ו/או אמינות המערכת.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                הלקוח מאשר כי בעת השימוש במערכת יפעל בהתאם ובכפוף להוראות כל דין
                וכי ידוע לו שהשימוש בשרות תוך הפרה של הוראות הדין יטיל עליו הן
                את האחריות האזרחית על שלל היבטיה למעשיו ו/או מחדליו והן את
                האחריות הפלילית למעשיו ו/או מחדליו והוא הדין גם ביחס לכל נזק או
                הפסד אחר אשר ייגרמו מהשימוש בשרות.
              </p>
            </section>

            {/* Payment and Additional Costs */}
            <section className="mb-8">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                תשלום בגין השרות ועלויות נוספות
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                הלקוח מאשר כי התשלום ששילם בגין השרות הביא בחשבון את כל המגבלות
                וההסתייגויות שבתקנון זה לעיל ולהלן. כן מאשר הלקוח, כי ידוע לו
                שהשימוש במערכת מחייב חיבור לרנטרנט וכי כל החיובים הכרוכים בעשיית
                שימוש בשרות יחולו עליו בלבד וזאת בנוסף לתשלום ששילם בגין במערכת
                לשרות.
              </p>
            </section>

            {/* Permission to Use Service */}
            <section className="mb-8">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                הרשות להשתמש בשרות
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                הרשות ניתנת בזאת ללקוח לעשיית שימוש פרטי בלבד וחל איסור להעביר
                שרות זה לכל צד ג' אשר איננו הלקוח עצמו.
              </p>
            </section>

            {/* Cancellation Policy */}
            <section className="mb-8">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                מדיניות ביטולים
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                הואיל ומדובר במנוי הנרכש לתקופה קצובה בכל פעם אין אפשרות לבטל את
                השרות ובמקרה של ביטול לא יהיה הלקוח זכאי להחזר כספי כלשהו. במקרה
                של סתירה בין האמור לעיל לבין הוראות כל דין קוגנטי, יגברו הוראות
                הדין הקוגנטי ובכל מקרה אחר רואים באישור הלקוח את תקנון זה כאילו
                נתן הסכמתו כי במקרה של ביטול לא יהא זכאי להחזר כספי מלא או חלקי.
              </p>
            </section>

            {/* Consent to Advertising */}
            <section className="mb-8">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                הסכמה לקבלת פרסומות והודעות
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                אישורו של תקנון זה מהווה הסכמה מטעם הלקוח לקבלת דבר פרסומת כנדרש
                על פי הוראות סעיף 30 א (ג) לחוק התקשורת (בזק ושידורים),
                תשמ"ב-1982 (להלן: "חוק התקשורת").
              </p>
            </section>

            {/* Privacy Restriction */}
            <section className="mb-8">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                סמכות הגבלת פרטיות
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                אנו שומרים על סודיות הלקוח, פרטי האשראי לא נשמרים במערכת, אנו
                מתחייבים לא להעביר את פרטי האשראי לצד ג אלא בהוראת בית משפט.
              </p>
            </section>

            {/* Law */}
            <section className="mb-8">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                דין
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                על הוראות תקנון זה יחולו דיני מדינת ישראל בלבד.
              </p>
            </section>

            {/* Jurisdiction */}
            <section className="mb-8">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                סמכות שיפוט
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                בכל סכסוך שבין הלקוח לחברה תהא נתונה הסמכות המקומית לבתי המשפט
                במחוז מרכז ולהם בלבד.
              </p>
            </section>

            {/* Consumer Protection */}
            <section className="mb-8">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                ביטול עסקה בהתאם לתקנות הגנת הצרכן
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                "ביטול עסקה בהתאם לתקנות הגנת הצרכן (ביטול עסקה), התשע"א-2010
                וחוק הגנת הצרכן, התשמ"א-1981"
              </p>
            </section>

            {/* Contact Information */}
            <section className="mt-12 pt-8 border-t text-center">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                מ.פ איי טיי גרופ בעמ - MFiT Group LTD
              </h2>
              <div className="space-y-2 text-gray-700">
                <p className="font-semibold">כתובת העסק</p>
                <p>התאנה 16 לב הארץ, כפר קאסם</p>
                <p className="mt-4">
                  <strong>טלפון:</strong> 07-33220019
                </p>
                <p>
                  <strong>מייל:</strong>{" "}
                  <a
                    href="mailto:wecare@mfitgroup.com"
                    className="text-primary hover:underline"
                  >
                    wecare@mfitgroup.com
                  </a>
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
